import { put, call } from 'redux-saga/effects'
import { actions as adActions } from 'src/features/ads/AdsSlice'

/**
 * Handles the prestitial advertisement request in a Redux-Saga flow
 *
 * @param {Function} services - Service container with dependencies
 * @param {Object} prestitialAd - Prestitial advertisement configuration object
 *
 * @throws {Error} Logs error to console if ad generation fails
 * @returns {void}
 */
export function* prestitialAdRequest(services, prestitialAd) {
  const Ads = services('Ads')

  if (!prestitialAd) {
    return
  }

  try {
    const ad = yield call([Ads, 'generateAd'], prestitialAd)
    yield put(adActions.prestitialAdFinished(ad))
  } catch (e) {
    console.error(e)
  }
}
